import { useDispatch } from 'react-redux';
import { metalStreamFunding } from '../store/actions/funding/fundingActions';

import { metalStreamDataHelper } from '../util/helpers/metalStreamDataHelper';
import useApplicationUid from './useApplicationUid';
import { useMetalStreamData } from './useMetalStreamData';

const useMetalStreamFundingSourceDispatch = () => {
  const dispatch = useDispatch();
  const { MetalStreamData } = useMetalStreamData();

  const { ApplicationUid } = useApplicationUid();

  const metalStreamFundingSourceDispatch = ({ data, onSuccess, onError }) => {
    const UseAccountBalance = metalStreamDataHelper(
      MetalStreamData,
      'UseAccountBalance',
    );
    const shouldSkip = UseAccountBalance === true;

    if (shouldSkip) {
      onSuccess();
      return;
    }

    dispatch(
      metalStreamFunding({
        ApplicationUid,
        data,
        onSuccess,
        onError,
      }),
    );
  };

  return { metalStreamFundingSourceDispatch };
};

export default useMetalStreamFundingSourceDispatch;
